//import React from "react";
import React, { history, useEffect, useState, useMemo } from "react";
import { useSearchParams } from 'react-router-dom';
import './../css/bootstrap.min.css';
import '../assets/css/custome.css';
import '../assets/css/media.css';
import '../assets/css/animate.min.css';
import { BrowserRouter } from "react-router-dom";
import MainContent from "./mainContent/MainContent";
import Appbar from "./header/header";
import PublicHeader from "./header/publicHeader";

import HeaderHTA from "./header/headerHTA";
import HeaderHTO from "./header/headerHTO";

import PublicHeaderHTA from "./header/publicHeaderHTA";
import PublicHeaderHTO from "./header/publicHeaderHTO";

import Footer from "./footer/index";
import MetaTags from 'react-meta-tags';

function Layout() {
  const [pageURLName, setPageURLName] = useState('');
  const [pageURLArray, setPageURLArray] = useState(['/studentRegistrationCareerChoices','/studentRegistrationFieldsofInterest','/studentRegistrationSchoolInfo', '/studentRegistrationPersonalInfo','/applyJobProfile', '/subscribetocareer','/companyDetails','/aboutus','/contactus','/jobSummary','privacyPolicy','/aijobSummary', '/jobsByCompany', '/ourlibrary', '/educationTraining', '/employerDirectory', '/companyRegister', '/studentRegistration', '/postResume', '/schoolDetails', '/schoolList', '/movingToTheArea', '/events', '/CompanyListByIndustry', '/industries', '/videoLibrary', '/marketSupport', '/locallifeCommunities', '/availableJobs', '/jobsummary', '/companyDetails']);
  const staticData = require('../constants/'+process.env.React_App_Static_Folder+'/static-data.json');
  useEffect(() => {

    //alert(window.location.pathname)
    // setPageURLName(window.location.pathname); 
    //alert("test");



  }, []);

  return (


    <BrowserRouter >
      {/* <Appbar/> */}
      {/* <PublicHeader/> */}



      {(() => {

        if(process.env.React_App_Static_Folder == "HTO"){
          if (pageURLArray.indexOf(window.location.pathname) > -1) {
            return (<> <PublicHeaderHTO /> </>);
          } else {
            return (<> <HeaderHTO /></>);
          }
        }else  if(process.env.React_App_Static_Folder == "HTA"){
          if (pageURLArray.indexOf(window.location.pathname) > -1) {
            return (<> <PublicHeaderHTA /> </>);
          } else {
            return (<> <HeaderHTA /></>);
          }
        }else{
          if (pageURLArray.indexOf(window.location.pathname) > -1) {
            return (<> <PublicHeader /> </>);
          } else {
            return (<> <Appbar /></>);
          }
        }
       

      })()}


 

      <MainContent />
      <Footer />
    </BrowserRouter>


  );
}

export default Layout;